import BaseFilter from "./base_filter"
import { createFormGroup, createSelect, createSummary } from "./dom"

export default class GenericSelectionFilter extends BaseFilter {
  createForm() {
    super.createForm()

    this.input = createSelect(this.definition.options || [])
    this.element.append(createFormGroup(this.definition.title, this.input))
    this.appendApplyButton()

    return this.element
  }

  read() { return this.result(this.input.value, this.input.value !== "") }

  summary(value) {
    const option = (this.definition.options || []).find((entry) => String(entry.value) === String(value))
    return createSummary(this.definition.title, option?.label || value)
  }
}
